import * as React from 'react';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const ProductBlockContainerError = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-block-container-error"
    }, /*#__PURE__*/ React.createElement(Alert, {
        variant: "warning",
        className: "alert-m-default"
    }, getLabel('products.banner.errorMessage')));
};

export { ProductBlockContainerError };
//# sourceMappingURL=ProductBlockContainerError.js.map
